import React from 'react';
import { Box, Container, Typography, IconButton, Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';

const FooterWrapper = styled(Box)({
  background: 'linear-gradient(180deg, #0a1628 0%, #060d16 100%)',
  borderTop: '1px solid rgba(255, 255, 255, 0.05)',
  padding: '40px 0',
});

const Logo = styled(Typography)({
  fontWeight: 700,
  fontSize: '1.25rem',
  background: 'linear-gradient(135deg, #60a5fa 0%, #a78bfa 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
});

const FooterLink = styled(Link)({
  color: '#94a3b8',
  textDecoration: 'none',
  fontSize: '0.9rem',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: '#60a5fa',
  },
});

const SocialButton = styled(IconButton)({
  color: '#64748b',
  padding: '8px',
  transition: 'all 0.2s ease',
  '&:hover': {
    color: '#60a5fa',
    backgroundColor: 'rgba(96, 165, 250, 0.1)',
  },
});

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {/* Brand */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: '6px',
                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.875rem' }}>
                D
              </Typography>
            </Box>
            <Logo>DWMS</Logo>
          </Box>

          {/* Links */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <FooterLink to="/docs">Docs</FooterLink>
            <FooterLink to="/login">Sign In</FooterLink>
          </Box>

          {/* Social */}
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <SocialButton
              component={MuiLink}
              href="mailto:info@awclinicguyana.com"
              target="_blank"
              size="small"
            >
              <EmailIcon fontSize="small" />
            </SocialButton>
          </Box>
        </Box>

        {/* Copyright */}
        <Box sx={{ textAlign: 'center', mt: 3, pt: 3, borderTop: '1px solid rgba(255, 255, 255, 0.05)' }}>
          <Typography sx={{ color: '#475569', fontSize: '0.8rem' }}>
            © {currentYear} Dr. Wilburg's Medical Services. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
